import { analytics, performance } from '../firebase';
import { logEvent } from 'firebase/analytics';
import { trace } from 'firebase/performance';

// Monitoring Service for Analytics, Error Logging, and Performance
const monitoringService = {
    // Log a custom event to Analytics
    logEvent: (eventName, params = {}) => {
        try {
            if (analytics) {
                logEvent(analytics, eventName, params);
            }
        } catch (error) {
            // Silent fail - no console logging in production
        }
    },

    // Log an error (simulating Crashlytics for Web via Analytics)
    logError: (error, context = {}) => {
        try {
            if (analytics) {
                logEvent(analytics, 'exception', {
                    description: error.message || String(error),
                    fatal: false,
                    ...context
                });
            }
        } catch (e) {
            // Silent fail - no console logging in production
        }
    },

    // Start a custom performance trace
    startTrace: (traceName) => {
        try {
            if (performance) {
                const t = trace(performance, traceName);
                t.start();
                return t;
            }
        } catch (error) {
            // Silent fail
        }
        return null;
    },

    // Stop a custom performance trace
    stopTrace: (traceInstance) => {
        try {
            if (traceInstance) {
                traceInstance.stop();
            }
        } catch (error) {
            // Silent fail
        }
    }
};

export default monitoringService;
